<template>
  <div
    class="flex items-center gap-[11px]"
    :class="{
      'justify-center': align === 'center',
      'justify-left': align === 'left',
      'justify-end': align === 'right',
      'cursor-not-allowed opacity-50': disabled,
      'cursor-pointer hover:bg-[--v3-input-lists-inputlistheaderbg]': !disabled,
    }"
  >
    <Icon :name="icon" class="size-[14px] text-[--v3-blue-gray-bluegray-300]" />
    <span class="v3-body-regular-400-line-height-1.5 text-[--v3-global-textsecondarycolor]">{{ label }}</span>
  </div>
</template>

<script lang="ts" setup>
import Icon from '@/common/components/atoms/Icon';

withDefaults(
  defineProps<{
    label: string,
    icon: string,
    align?: 'left' | 'right' | 'center',
    disabled?: boolean
  }>(), {
    align: 'left',
  });
</script>

<style scoped>
/* Add your styles here */
</style>
